export const errorStrings = {
	firstName: 'Please include your first name',
	lastName: 'Please include your last name',
	email: 'Please include a valid email',
	password1: 'Please include a valid password',
	password2: 'Please include a valid password',
};
